import { MappedImage } from "../../utils/fw"
import { ModalWrapper, VimeoFrame } from "src/utils/fw-extension";
import RecentRelease from "./modals/recentRelease";
import ManagementPeople from "./modals/managementPeople";
import Compliance from "./modals/compliance";
import RiskManag from "./modals/riskManag";
import VidAssure from "./modals/vidAssure";
import VidCyberAtt from "./modals/vidCyberAtt";
import VidMeetCom from "./modals/vidMeetCom";
import VidEducate from "./modals/vidEducate";
import ListenHere from "./modals/listenHere";
import LeftMag from "./modals/leftMag";
import RightMag from "./modals/rightMag";
import WelcomeFuture from "./modals/WelcomeFuture";

const dismissStyle = {
	height: "6%",
	left: "68%",
	top: "12%",
	width: "4%",
}
const dismissHTML = "X"

const modalOverrides = { dismissStyle, dismissHTML }

export default {
	background: "https://assets.swoogo.com/uploads/full/3027221-65242cb4aed97.png",
	links: [
		{
			height: "29.2%",
			label: "How can we help?",
			left: "82.5%",
			modal: <RightMag />,
			modalOverrides: {
				dismissStyle: {
					height: "3.7%",
					left: "77.5%",
					top: "6.4%",
					width: "2.1%",
				}
			},
			top: "55%",
			width: "6.3%",
		},
		{
			height: "29.2%",
			label: "More from the ISF",
			left: "11%",
			modal: <LeftMag />,
			modalOverrides: {
				dismissStyle: {
					height: "3.7%",
					left: "77.5%",
					top: "6.4%",
					width: "2.1%",
				}
			},
			top: "55%",
			width: "6.3%",
		},
		{
			height: "22.2%",
			label: "Listen Here",
			left: "46.3%",
			modal: <ListenHere />,
			modalOverrides: {
				dismissStyle: {
					height: "3.7%",
					left: "80.5%",
					top: "5.4%",
					width: "2.1%",
				}
			},
			top: "60%",
			width: "8.3%",
		},
		{
			height: "35.2%",
			label: "ISF Assure",
			left: "1.3%",
			modal: <VidAssure />,
			modalOverrides: {
				dismissStyle: {
					height: "3.7%",
					left: "76.5%",
					top: "13.4%",
					width: "2.1%",
				}
			},
			top: "19%",
			width: "30.3%",
		},
		{
			height: "17.2%",
			label: "Prepare for the next Cyber Attack",
			left: "82%",
			modal: <VidCyberAtt />,
			modalOverrides: {
				dismissStyle: {
					height: "3.7%",
					left: "76.5%",
					top: "13.4%",
					width: "2.1%",
				}
			},
			top: "17%",
			width: "16.7%",
		},
		{
			height: "17.2%",
			label: "Meet your local comunity",
			left: "82%",
			modal: <VidMeetCom />,
			modalOverrides: {
				dismissStyle: {
					height: "3.7%",
					left: "76.5%",
					top: "13.4%",
					width: "2.1%",
				}
			},
			top: "30%",
			width: "16.7%",
		},
		{
			height: "14.2%",
			label: "Welcome to the future",
			left: "69%",
			modal: <WelcomeFuture />,
			modalOverrides: {
				dismissStyle: {
					height: "3.7%",
					left: "76.5%",
					top: "13.4%",
					width: "2.1%",
				}
			},
			top: "22%",
			width: "11.7%",
		},
		{
			height: "14.2%",
			label: "Educate and inspire the next generation",
			left: "69%",
			modal: <VidEducate />,
			modalOverrides: {
				dismissStyle: {
					height: "3.7%",
					left: "76.5%",
					top: "13.4%",
					width: "2.1%",
				}
			},
			top: "38%",
			width: "11.7%",
		},
		{
			height: "23.2%",
			label: "Access the latest ISF products related to this key area - Recent Releases",
			left: "32.3%",
			modal: <RecentRelease />,
			modalOverrides: {
				dismissStyle: {
					height: "2.7%",
					left: "78%",
					top: "7.4%",
					width: "1.1%",
				}
			},
			top: "35%",
			width: "8.3%",
		},
		{
			height: "21.6%",
			label: "Access ISF products related to this key area - Management",
			left: "41.3%",
			modal: <ManagementPeople />,
			modalOverrides: {
				dismissStyle: {
					height: "4%",
					left: "77.5%",
					top: "7%",
					width: "2%",
				}
			},
			top: "35.5%",
			width: "8.2%",
		},
		{
			height: "21.3%",
			label: "Access ISF products related to this key area - Compliance",
			left: "50.3%",
			modal: <Compliance />,
			modalOverrides: {
				dismissStyle: {
					height: "4%",
					left: "77.5%",
					top: "5.5%",
					width: "2%",
				}
			},
			top: "35.5%",
			width: "8.5%",
		},
		{

			height: "19.5%",
			label: "Access ISF products related to this key area - Risk Management",
			left: "59.2%",
			modal: <RiskManag />,
			modalOverrides: {
				dismissStyle: {
					height: "4%",
					left: "77.5%",
					top: "5.5%",
					width: "2%",
				}
			},
			top: "35.7%",
			width: "8.3%",
		},
		{
			width: "8%",
			height: "16.2%",
			left: "46.3%",
			top: "82%",
			label: "Back to Atrium",
			href: "/atrium"
		}
	],
	name: "exploration-zone",
}
